import React from "react";
import { mdContactUs, ContactUsMetaData } from "../../../models/contact-us";
import { StaticHelper } from "../../../shared/static-helper";
import { mdFormControl } from "../../../shared/form-control";
import { mdCallResponse } from "../../../models/call-response";
import { mdKeyValue } from "../../../models/key-value";
import { mdCurrency } from "../../../models/currency";
import { BaseComponent } from "../base/BaseComponent";
import { Row, Form, Col } from "antd";
import {
  RequiredValidator,
  MaxLengthValidator,
  MailValidator
} from "../../../shared/validation-attributes";

export default class ContactUsComponent extends BaseComponent {
  render() {
    let currencies = [];
    if (this.g.currencies) {
      currencies = this.g.currencies.map((cp: mdCurrency, i) => {
        return new mdKeyValue(cp.name, cp.id);
      });
    }
    this.initShorts();
    return (
      <div className="form-header gx-mb-6 gx-text-center">
        <h1 className="text-big">{this.p.title || this.lang.ContactUs}</h1>
        <p style={{ fontSize: 25, textAlign: "left" }}>{this.p.formHeading}</p>
        <Form
          onSubmit={this.onSubmit}
          className="gx-signin-form gx-form-row0 large-size-form"
        >
          {this.p.type !== "OTC_form" ? (
            <Row className="flx-turn">
              <Col md={12}>
                {this.antd.textFormItem(this.f.name, false)}
                {this.antd.textFormItem(this.f.email, false)}
                {this.antd.textFormItem(this.f.contact_no, false)}
              </Col>
              <Col md={12} className="message-input">
                {this.antd.textAreaFormItem(this.f.message, 15, false)}
              </Col>
            </Row>
          ) : (
            <Row className="flx-turn">
              <Col md={12}>
                {this.antd.textFormItem(this.f.volume, false)}
                {this.antd.textFormItem(this.f.name, false)}
                {this.antd.textFormItem(this.f.contact_no, false)}
              </Col>

              <Col md={12} className="message-input">
                <Col
                  style={{
                    transform: "translateX(-2.5%)",
                    marginBottom: "80px",
                    width: "89%"
                  }}
                >
                  {this.antd.selectFormItemWithPlaceholder(
                    this.f.currency,
                    currencies,
                    false,
                    false,
                    "",
                    "",
                    null,
                    this.formItemLayout
                  )}
                </Col>
                {this.antd.textFormItem(this.f.location, false)}
                {this.antd.textFormItem(this.f.email, false)}
              </Col>
            </Row>
          )}
          <div className="gx-text-center">
            <div className="gx-text-center cta-btn gx-mb-4 shake-horizontal">
              <button
                onClick={this.onSubmit}
                type="submit"
                style={{ padding: "30px 70px" }}
              >
                {this.lang.Send}
              </button>
            </div>
          </div>
        </Form>
      </div>
    );
  }

  model: mdContactUs;
  showErrors: boolean;

  constructor(props) {
    super(props);
    this.init();
  }

  formItemLayout = {
    wrapperCol: { xs: 24, sm: 14, md: 12 }
  };

  init() {
    this.model = new mdContactUs(true);
    this.state = {
      form: {
        name: new mdFormControl(
          this.model.name,
          "name",
          this.lang.Name,
          [
            new RequiredValidator(this.lang.RequiredFormat),
            new MaxLengthValidator(
              this.lang.MaxLengthFormat2,
              ContactUsMetaData.nameMaxLength
            )
          ],
          "",
          "99px",
          "230%"
        ),
        contact_no: new mdFormControl(
          this.model.contact_no,
          "contact_no",
          this.lang.ContactNo,
          [
            new RequiredValidator(this.lang.RequiredFormat),
            new MaxLengthValidator(
              this.lang.MaxLengthFormat2,
              ContactUsMetaData.contactNoMaxLength
            )
          ],
          "",
          "99px",
          "230%"
        ),
        email: new mdFormControl(
          this.model.email,
          "email",
          this.lang.Email,
          [
            new MailValidator(this.lang.InvalidEmail),
            new MaxLengthValidator(
              this.lang.MaxLengthFormat2,
              ContactUsMetaData.emailMaxLength
            )
          ],
          "",
          "99px",
          "230%"
        ),
        message: new mdFormControl(
          this.model.message,
          "message",
          this.lang.ContactUsMessage,
          [
            new MaxLengthValidator(
              this.lang.MaxLengthFormat2,
              ContactUsMetaData.messageMaxLength
            )
          ],
          "",
          "340px",
          "230%"
        ),

        volume: new mdFormControl(
          this.model.transaction_volume,
          "volume",
          this.lang.TransactionVolume,
          null,
          "",
          "99px",
          "230%"
        ),
        location: new mdFormControl(
          this.model.location,
          "location",
          this.lang.Location,
          null,
          "",
          "99px",
          "230%"
        ),
        currency: new mdFormControl(
          this.model.currency,
          "currency",
          this.lang.Currency,
          null,
          "",
          "99px",
          "230%",
          "Select a currency"
        )
      },

      disableSubmitButton: false,
      showSubmitResponse: false,
      submitResponseClass: "",
      submitResponse: ""
    };
  }

  onSubmit = e => {
    e.preventDefault();
    debugger;
    this.showErrors = true;
    // stop here if form is invalid

    if (!this.validateForm("form")) {
      this.log.debug("invalid form");
      return;
    }

    //everything is fine, now save the data
    this.props.updateGlobalProperty(global.propKeys.showMainLoader, true);
    this.updateState({
      form: { ...this.state.form },
      disableSubmitButton: true
    });
    let formData: mdContactUs = this.getFormData(
      this.state.form
    ) as mdContactUs;
    formData.uuid = StaticHelper.getUUID();

    this.http
      .post(this.constants.EndPoints.PostContactUs, formData)
      .then((res: mdCallResponse) => {
        let submitResponseClass = "text-danger";
        let submitResponse = "";
        if (res) {
          submitResponse = res.message.replace("\n", "<br/>");
          if (res.isSuccess) {
            this.successNotification(res.message);
          } else {
            this.errorNotification(res.message);
          }
        } else {
          this.errorNotification(this.lang.ErrorOccured);
        }

        this.updateState({
          form: {
            ...this.state.form,
            showSubmitResponse: true,
            submitResponseClass: submitResponseClass,
            submitResponse: submitResponse
          }
        });
        setTimeout(() => {
          this.props.history.push(this.constants.RoutePaths.Home);
        }, this.constants.ResponseMessageTimeout * 1000);
        this.props.updateGlobalProperty(global.propKeys.showMainLoader, false);
      })
      .catch(error => {
        this.log.debug(error);
        this.props.updateGlobalProperty(global.propKeys.showMainLoader, false);
      });
  };
}
